import Vue from 'vue'
import Global from '@/scripts/Global'
import {
    Post
} from '@/classes/Post'
import {
    CPUtils
} from '@/scripts/Utils'
import MessageBuilder from '@/Builder/Message.builder'
import FileApi from '@/scripts/api/file.api'
import {
    serverBus
} from '@/main'
import SessionManager from '@/Manager/Session.manager'
import VueSignals from '@/scripts/VueSignals'
import CPLink from '@/components/CPLink'
import MediaModal from '@/components/SmallOverlay/MediaModal/MediaModal.vue'
import config from '@/scripts/config'
import axios from 'axios'

export default {
    name: 'Message',
    data: function() {
        return {
            arrActiveChannelUsers: SessionManager.GetActiveChannelUsers(),
            loggedInUserId: SessionManager.getLoggedInUserId(),
            isDevelop: Global.isDevelop(),
            postHoverID: '',
            activeChannelDoc: SessionManager.getActiveChannel(),
            yesterday: new Date(new Date().setDate(new Date().getDate() - 1)).toLocaleDateString("en-DE"),
            today: new Date().toLocaleDateString("en-DE"),
            showSeenBy: '',
            user: null,
            initialMessageId: Global.SaltID(5),
            activeChannelId: SessionManager.getActiveChannelId(),
            files: [],
            messageReady: true,
            showFileInfo: false,
        }
    },
    components: {
        CPLink,
    },
    mixins:[MediaModal],
    props: {
        message_doc: Object,
        local_user_id: String,
        firstInBlock: Boolean,
        tunnle_message: Array,
        messageQueue: Array,
        ChannelUsersObjects: Array,
        messageIndex: Number
    },
    created() {
        this.user = this.getUserData(this.message_doc.user_id);
    },
    beforeMount() {
        this.computeFiles();
    },
    watch: {
        message_doc(value) {
            this.computeFiles();
            this.user = this.getUserData(this.message_doc.user_id);
        }
    },
    mounted() {
        this.postHoverID = ''
        this.arrActiveChannelUsers = SessionManager.GetActiveChannelUsers()
        serverBus.$on(VueSignals.LOADED_MESSAGES_IDS, (ids) => {
            for (let i = 0; i < ids.length; i++) {
                if (this.message_doc.post_id == ids[i]) {
                    this.message_doc.not_viewed_user_ids.splice(this.message_doc.not_viewed_user_ids.indexOf(this.loggedInUserId), 1)
                }
            }
        })
        serverBus.$on(VueSignals.CHANNEL_USERS_CHANGED, (user_id) => {
            // The user of the message changed his picture
            if (this.user.user_id == user_id) {
                this.user = this.getUserData(user_id);
            }
        });
        // @TODO could be deleted
        // serverBus.$on(VueSignals.READ_MESSAGE_IDS, (ids) => {
        //   setTimeout(function(){
        //     Global.globalValue(VueSignals.LOADED_MESSAGES_IDS, ids)
        //   },1000)
        // })

        /********************Edit Message Notify****************/
        // serverBus.$on(VueSignals.SOCKET_POST_EDITED, (data) => {
        //   if(data.event == VueSignals.SOCKET_POST_EDITED &&
        //     data.channel_id == SessionManager.getActiveChannelId()){
        //       if(this.message_doc.post_id == data.post.post_id){
        //         this.message_doc.origin_parsed = data.post.origin_parsed
        //         this.message_doc.origin = data.post.origin
        //         this.message_doc.parsed_items = data.post.parsed_items
        //         this.message_doc.edited_at = data.post.edited_at
        //       }
        //   }
        // })
    },
    computed: {
        message_date: function() {
            let timestamp = this.message_doc.created_at
            if (typeof this.message_doc.edited_at != 'undefined') {
                timestamp = this.message_doc.edited_at
            }
            return new Date(timestamp * 1000).toLocaleDateString(SessionManager.getLoggedInUser().chat_visuals.language, {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            })

        },
        message_time: function() {
            let timestamp = this.message_doc.created_at
            if (typeof this.message_doc.edited_at != 'undefined') {
                timestamp = this.message_doc.edited_at
            }
            return new Date(timestamp * 1000).toLocaleTimeString(SessionManager.getLoggedInUser().chat_visuals.language, {
                hour: '2-digit',
                minute: '2-digit'
            })

        }
    },
    methods: {
        hasComponentAttached(text) {
            return CPUtils.hasComponentAttached(text)
        },
        hasURL(message) {
            return CPUtils.hasURL(message)
        },
        MessageParsing(message) {
            return MessageBuilder.decode(message)
        },
        applyStyling(text) {
            let SpecialChars = CPUtils.getStylingChars()
            if (SpecialChars.indexOf(text[0]) > -1) {
                text = " " + text
            }
            return CPUtils.GetMessageDecodeDisplay(text)
        },
        getSubStyle(inputFeed) {
            let html = ''
            let char = ''
            let charAt = -1
            let buffer = ''
            let specialCharFound = false

            for (let letterPos = 0; letterPos < inputFeed.length; letterPos++) {
                if (inputFeed[letterPos] in config.MESSAGE_TEXT_STYLE) {
                    specialCharFound = true
                    if (char == '') {
                        char = inputFeed[letterPos]
                        charAt = letterPos
                    } else if (inputFeed[letterPos] == char) {
                        html += "<" + config.MESSAGE_HTML_STYLE[char] + ">" + inputFeed.substring(charAt + 1, letterPos) + "<" + config.MESSAGE_HTML_STYLE[char] + ">"
                        char = ''
                        charAt = -1
                        specialCharFound = false
                    } else if (char != '' && char != inputFeed[letterPos]) {
                        let tempChar = inputFeed[letterPos]
                        let tempHtml = ''
                        for (let letterSubPos = letterPos + 1; letterSubPos < inputFeed.length; letterSubPos++) {
                            if (inputFeed[letterSubPos] == tempChar) {
                                tempHtml = "<" + config.MESSAGE_HTML_STYLE[tempChar] + ">" +
                                    inputFeed.substring(letterPos + 1, letterSubPos) +
                                    "</" + config.MESSAGE_HTML_STYLE[tempChar] + ">"
                                letterPos = letterSubPos + 1
                                break
                            }
                        }
                        html += "<" + config.MESSAGE_HTML_STYLE[char] + ">" + tempHtml + "</" + config.MESSAGE_HTML_STYLE[char] + ">"
                        char = ''
                        charAt = -1
                        specialCharFound = false
                    }
                } else {
                    if (!specialCharFound)
                        html += inputFeed[letterPos]
                }
            }
            return html
        },
        GetURLHTML(text) {
            return CPUtils.GetURLHTML(text)
        },
        getURL(link) {
            return CPUtils.getURL(link)
        },
        getEmoji(emojiID) {
            return CPUtils.getEmojiIMG(emojiID)
        },
        FilePreview(file_id) {
            let container = document.getElementById(this.initialMessageId + file_id + '_' + this.message_doc.post_id + '_container');
            if (container && container.childNodes.length > 0) {
                // There is already a preview there
                return;
            }
            FileApi.Preview(file_id).then(res => {
                if (typeof res.data != 'undefined' && res.data.result) {
                    let img = document.createElement("img")
                    img.classList = "img-preview"
                    img.id = Global.SaltID(5)
                    img.src = "data:image/jpeg;base64," + res.data.data
                    img.onclick = ( _ => {
                        Global.globalValue(VueSignals.SHOW_SMALL_MODAL, true)
                        Global.globalValue(VueSignals.SHOW_SMALL_MODAL_TYPE, VueSignals.MEDIA_MODAL)
                        Global.globalValue(VueSignals.SMALL_OVERLAY_DATA, {'url': res.data.data})
                    });
                    document.getElementById(this.initialMessageId + file_id + '_' + this.message_doc.post_id + '_container').appendChild(img)
                }
            }).catch(err => {
                console.log(err)
            })
        },
        FilePreview_with_download(file_id, file_name) {
            // FileApi.Preview(file_id).then(res => {
            let container = document.getElementById(this.initialMessageId + file_id + '_' + this.message_doc.post_id + '_container');
            if (container && container.childNodes.length > 0) {
                // There is already a preview there
                return;
            }
            FileApi.downloadFile(file_id, file_name, SessionManager.getActiveChannelId()).then(res => {
                // console.log('File Preview', res);
                if (typeof res.data != 'undefined' && res.data.result) {
                    let fileType = this.computeFileType(res.data.link);
                    let img;
                    // console.log('type', fileType);
                    if (fileType == 'image') {
                        img = document.createElement("img");
                        img.src = res.data.link
                    } else if (fileType == 'video') {
                        img = document.createElement("video");
                        img.src = res.data.link
                        // let source = document.createElement("source");
                        // source.src = res.data.link;
                        // source.type = 'video';
                        // img.appendChild(source);
                    } else {
                        return;
                    }
                    img.classList = "file-preview-append pointer"
                    img.id = Global.SaltID(5)
                    // img.src = res.data.link
                    img.onclick = ( _ => {
                        Global.globalValue(VueSignals.SHOW_SMALL_MODAL, true)
                        Global.globalValue(VueSignals.SHOW_SMALL_MODAL_TYPE, VueSignals.MEDIA_MODAL)
                        Global.globalValue(VueSignals.SMALL_OVERLAY_DATA, {'url': res.data.link})
                    });
                    document.getElementById(this.initialMessageId + file_id + '_' + this.message_doc.post_id + '_container').appendChild(img)
                }
            }).catch(err => {
                console.log(err)
            })
        },
        DecodeMessage(message_doc) {
            let text = message_doc.origin_parsed
            if (typeof text != 'undefined') {
                let textArr = text.split(/(\[[A-F0-9]{32}\])/g)
                return textArr
            }
        },
        Display(text) {
            if (text.length == 34 &&
                text[0] == "[" &&
                text[33] == "]") {
                if (text.slice(1, 33) in this.$props.message_doc.parsed_items) {
                    return this.$props.message_doc.parsed_items[text.slice(1, 33)]
                }
            }
            return {
                "text": text,
                "type": "text"
            }
        },
        DisplayWithURL(pargraph) {
            let itemBeforeURL, itemAfterURL
            let structuredURLMessage = []
            let computingText = pargraph
            // Multiples link can occurs in one parragraph
            while (this.hasURL(computingText)) {
                    itemBeforeURL = this.getBeforeText(computingText)
                    structuredURLMessage.push({
                        "type": "text",
                        "value": itemBeforeURL
                    })
                    computingText = computingText.substring(itemBeforeURL.length)
                    let URL = this.getURL(computingText)
                    structuredURLMessage.push({
                        "type": "URL",
                        "value": URL
                    })
                    computingText = this.getRestText(computingText)
            }
            // Rest of the message without link
            if (computingText) {
                structuredURLMessage.push({
                    'type': 'text',
                    'value': computingText
                })
            }
            return structuredURLMessage
        },
        ShowMention(id, type) {
            Global.globalValue(VueSignals.RIGHT_SIDEBAR_COLLAPSED, false)
            if (window.innerWidth <= 900) {
                Global.globalValue(VueSignals.SHOW_RIGHT_SIDEBAR_MOBILE, true)
            }
            Global.globalValue(VueSignals.SHOW_MENTION_DETAILS, {
                "data_id": id,
                "type": type
            })
        },
        getUsername(user_id) {
            return SessionManager.getUser(user_id).username
        },
        getRestText(text) {
            let returnText = ''
            let URL = CPUtils.getURL(text);
            // while (CPUtils.getURL(text).length > 0) {
            //     returnText += text.slice(text.indexOf(CPUtils.getURL(text)) + CPUtils.getURL(text).length)
            //     text = text.slice(text.indexOf(CPUtils.getURL(text)) + CPUtils.getURL(text).length)
            // }
            if (URL.length > 0) {
                returnText += text.slice(text.indexOf(URL) + URL.length)
                // text = text.slice(text.indexOf(URL) + URL.length)
            }
            return returnText
        },
        positionURLS(text) {
            return text.split(" ")
        },
        getBeforeText(text) {
            let returnText = ''
            if (CPUtils.getURL(text).length > 0) {
                returnText += text.slice(0, text.indexOf(CPUtils.getURL(text)))
                text = text.slice(0, text.indexOf(CPUtils.getURL(text)))
            }
            return returnText
        },
        DownloadFile(file_id, file_name) {
            console.log('waaa');
            if (Global.isMobileClientUsed()) {
                // Xamarin function C#
                try {
                    window.top.invokeCSharpOpenDocument(SessionManager.getActiveChannelId(), file_id, file_name);
                } catch (err) {

                }
            } else {
                FileApi.downloadFile(file_id, file_name, SessionManager.getActiveChannelId()).then(res => {
                    if (typeof res.data.link != 'undefined') {
                        let file_path = res.data.link
                        var a = document.createElement('A')
                        a.href = file_path
                        a.download = file_path.substr(file_path.lastIndexOf('/') + 1)
                        document.body.appendChild(a);
                        a.click()
                    }
                })
            }
        },
        cleanText(text) {
            return text.replace(/\_|\*|\~/g, '')
        },
        getTimeTitle(timestamp) {
            return new Date(timestamp * 1000).toLocaleDateString("en", {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            })
        },
        getUserData(user_id) {
            if (user_id != SessionManager.getLoggedInUserId()) {
                let user = SessionManager.getUser(user_id)
                if (typeof user == 'undefined') {
                    return
                }

                if (this.activeChannelDoc.removed_users.indexOf(user.user_id) > -1) {
                    user.removed = true
                } else {
                    user.removed = false
                }
                return user
            } else if (user_id == SessionManager.getLoggedInUserId()) {
                return SessionManager.getLoggedInUser()
            }
        },
        displayMessageHeader() {
            return (this.messageIndex == 0 || this.showUser(this.message_doc, this.messageQueue[this.messageIndex - 1])) && (this.message_doc.type == 'normal' || this.message_doc.type == 'gif');
        },
        showUser(currentMessage, previousMessage) {
            if (typeof previousMessage == 'undefined') {
                return true
            }
            let timeCurrent = this.getTime(currentMessage.created_at)
            let timePrevious = this.getTime(previousMessage.created_at)

            if (currentMessage.user_id == previousMessage.user_id &&
                timeCurrent == timePrevious) {
                return false
            }
            return true
        },
        getTime(timestamp) {
            let date;
            if (timestamp != null) {
                date = new Date(timestamp * 1000);
            } else {
                date = new Date();
            }
            let hours = date.getHours();
            let minutes = date.getMinutes();
            if (hours < 10) {
                hours = '0' + hours;
            }
            if (minutes < 10) {
                minutes = '0' + minutes;
            }
            return hours + ":" + minutes;
        },
        ShowUserDetails(user_id){
          Global.globalValue(VueSignals.SHOW_USER_DETAILS, user_id)
        },
        displaySeenByPosition(event) {
            if (this.showSeenBy == this.message_doc.post_id) {
                var eventDoc, doc, body;
                event = event || window.event; // IE-ism
                // (This is to support old IE)
                if (event.pageY == null && event.clientY != null) {
                    eventDoc = (event.target && event.target.ownerDocument) || document;
                    doc = eventDoc.documentElement;
                    body = eventDoc.body;

                    event.pageX = event.clientX +
                        (doc && doc.scrollLeft || body && body.scrollLeft || 0) -
                        (doc && doc.clientLeft || body && body.clientLeft || 0);
                    event.pageY = event.clientY +
                        (doc && doc.scrollTop  || body && body.scrollTop  || 0) -
                        (doc && doc.clientTop  || body && body.clientTop  || 0 );
                }
                let element = document.getElementsByClassName('seen-by')[0];
                if (element) {
                    element.style.top = `${event.pageY}px`;
                    element.style.left = `${this.calculateFinalLeftPosition(element, event.pageX)}px`;
                } else {
                    setTimeout( _ => {
                        let elem = document.getElementsByClassName('seen-by')[0];
                        if (elem) {
                            elem.style.top = `${event.pageY}px`;
                            elem.style.left = `${this.calculateFinalLeftPosition(elem, event.pageX)}px`;
                        }
                    }, 10);
                }
            }
        },
        calculateFinalLeftPosition(element, positionX) {
            // This if for mobile. So the seen-by div is not hidden
            let windowWidth = window.innerWidth;

            if (windowWidth > 900) {
                return positionX;
            }

            let hoverWidth = element.offsetWidth;

            if ((positionX  + hoverWidth) >= windowWidth) {
                return windowWidth - hoverWidth;
            } else {
                return positionX;
            }

        },
        getUserName() {
            return this.getUserData(this.message_doc.user_id).username
        },
        getProfilePicture() {
            return this.getUserData(this.message_doc.user_id).image_doc
        },
        getFileExtension(filename) {
            return Global.getFileIcon(filename)
        },
        getFileSize(file_id){
            return Global.getFileSize(file_id, SessionManager.getActiveChannelId());
        },
        async computeFiles() {
            if (!_.isEmpty(this.message_doc.parsed_items)) {
                this.messageReady = false;
                for (let key in this.message_doc.parsed_items) {
                    if (this.message_doc.parsed_items[key].type == 'file') {
                        let file_id = this.message_doc.parsed_items[key].file_id;
                        let channel_id = SessionManager.getActiveChannelId();
                        let ff_elem = Global.getFileFromFolder(file_id, channel_id);
                        if (typeof ff_elem == 'undefined') {
                            let response = await FileApi.Details(file_id, channel_id);
                            let data = await response.data;
                            let size = '0 kb';
                            if (data.result) {
                                let result = await data.size;
                                size = Global.toByte(result);
                            } else {
                                size = this.$t('File not found');
                            }
                            this.message_doc.parsed_items[key].size = size;
                        } else {
                            if (ff_elem.hasOwnProperty('size')) {
                                let size = Global.toByte(ff_elem.size);
                                this.message_doc.parsed_items[key].size = size;
                            }
                            if (ff_elem.file_size_b != 0) {
                                let size = Global.toByte(ff_elem.file_size_b);
                                this.message_doc.parsed_items[key].size =  size;
                            } else {
                                let size = Global.toByte(ff_elem.file_size_kb_estimate, 1);
                                this.message_doc.parsed_items[key].size = size;
                            }
                        }
                    }
                }
            }
        },
    }
}
